import { render, staticRenderFns } from "./VirtualSelect.vue?vue&type=template&id=5a84bef5&scoped=true"
import script from "./VirtualSelect.vue?vue&type=script&lang=js"
export * from "./VirtualSelect.vue?vue&type=script&lang=js"
import style0 from "./VirtualSelect.vue?vue&type=style&index=0&id=5a84bef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84bef5",
  null
  
)

export default component.exports